import { DashboardModuleListItem } from '@domain-group/suit-theme'

import { generateUrls } from '@hooks/useTrainingCourse'

import type { TrainingCourseModel } from '@models/types'

const moduleText = (modules_count: number) => {
  if (modules_count === 0 || modules_count === 1){
    return 'Module'
  }
  return 'Modules'
}

const TrainingCourseListItem = (props: { trainingCourse: TrainingCourseModel }) => {
  const { trainingCourse } = props
  // @ts-expect-error TS2339
  const { modules_count, title } = trainingCourse

  const { editTrainingCourseUrl } = generateUrls(trainingCourse)

  const text = moduleText(modules_count)

  return (
    <DashboardModuleListItem
      href={editTrainingCourseUrl}
      title={title}
    >
      {/*
       // @ts-expect-error TS2339 */}
      <DashboardModuleListItem.TertiaryText>
        {modules_count} {text}
        {/*
       // @ts-expect-error TS2339 */}
      </DashboardModuleListItem.TertiaryText>
    </DashboardModuleListItem>
  )
}

export default TrainingCourseListItem
